import styled, { css } from 'styled-components';

export const ToggleWrapper = styled.div`
  padding: 8px;
  display: flex;
  align-items: center;
  position: relative;
  label {
    cursor: pointer;
  }
  ${(props) =>
    props.$loading &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: rgba(57, 62, 68, 0.8) url('/images/loader2.svg') no-repeat 50% 50%;
        background-size: 20px auto;
      }
    `}
`;

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;

  &:checked + span {
    background-color: #4caf50;
  }
  &:checked + span:before {
    transform: translateX(18px);
  }
`;

export const Slider = styled.span`
  position: relative;
  width: 40px;
  height: 22px;
  display: inline-block;
  background: #ccc;
  border-radius: 22px;
  margin-right: 12px;
  vertical-align: middle;
  transition: background 0.3s;
  &:before {
    position: absolute;
    content: '';
    height: 18px;
    width: 18px;
    left: 2px;
    top: 2px;
    background: #fff;
    border-radius: 50%;
    transition: 0.3s;
  }
`;
